module.exports = __webpack_public_path__ + "img/logo.5bc1d776.svg";